import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DataTableComponent from "../../common/DataTable/PrimeDataTable";
import axiosInstance from '../../../axiosInstance';

import ActivateDeactivateModal from '../../common/ActivateDeactivateModal';

const UserLogs = ({ persona }) => {
  const [t] = useTranslation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState();
  const navigate = useNavigate();
  const [paginationParams, setPaginationParams] = useState({
    limit: 10,
    offset: 0,
    sortField: "createdAt",
    sortOrder: -1,
    filters:{
      global: { value: null, matchMode: "contains" },
      entity_name: { value: null, matchMode: "contains" },
      actor: { value: null, matchMode: "contains" },
      action: { value: null, matchMode: "contains" },
      target: { value: null, matchMode: "contains" },
      resource: { value: null, matchMode: "contains" },
      entity_id: { value: null, matchMode: "contains" },
      createdAt: { value: null, matchMode: "contains" },
    }
  });
  let { resource } = useParams();
  if(resource=="subforms") resource="sub-forms"
 
  const singularAndCapitalize = str => str ? (str.endsWith("s") ? str.slice(0, -1) : str).replace(/^./, c => c.toUpperCase()) : "";
 
  useEffect(() => {
    setLoading(true);
    const fetchLogs = async () => {
      try {
        const response = await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/logs/${resource}`, { withCredentials: true }, {
          params: paginationParams
        })
        .catch((err) => {
            console.log(err);
        });
 
        setData(response.data.data);
        setTotal(response.data.total);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
  }, [resource, paginationParams, persona]);
 
  const onDataTableEvent = (event) => {
    setPaginationParams((prev) => ({
      ...prev,
      limit: event.rows,
      offset: event.first,
      sortField: event.sortField || prev.sortField,
      sortOrder: event.sortOrder || prev.sortOrder,
      // filters: event.filters || prev.filters,
    }));
  };
 
  const columns = [
    { field: "id", header: t("ID"), sortable: true, filter: true },
    ...(resource === "other" ? [{ field: "entity_id", header: t("Entity ID" ), sortable: true, filter: true }]:[]),
    { field: "entity_name", header: t(resource === "other" ? "Entity Name":`${singularAndCapitalize(resource)}  Name`), sortable: true, filter: true },
    { field: "actor", header: t("Actor"), sortable: true, filter: true },
    ...(resource === "other" ? [{ field: "resource", header: t("Resource"), sortable: true, filter: true }]:[]),
    ...(resource === "users"
      ? [{ field: "target", header: t("Target"), sortable: true, filter: true }]
      : []),
    { field: "action", header: t("Action"), sortable: true, filter: true },
    { field: "createdAt", header: t("Created at"), sortable: true, filter: true },
  ];
 
  const actions = [
    {
      text: "View",
      color: "primary",
      onClick: (row) => navigate(`/${persona}/logs/${resource}/log/${row.id}`)
    },
  ];
 
  const body = data.map((log) => ({
    id: log.id,
    ...( resource === "other"? {entity_id: log.entity_id}: {}),
    entity_name: log.entity_name,
    actor: `${log.actor_username} (${log.actor_email})`,
    ...(resource === "users"
      ? { target: `${log.target_username ? log.target_username : "N/A"} (${log.target_email ? log.target_email : "N/A"})` }
      : {}),
    action: log.action,
    ...( resource === "other"? {resource:log.resource}:{}),
    // fieldChanges: JSON.stringify(JSON.parse(log.field_changes), null, 2),
    createdAt: new Date(log.createdAt).toLocaleString('en-GB'),
  }));
 
  return (
    <div>
      <DataTableComponent
        data={body}
        columns={columns}
        loading={loading}
        paginationParams={paginationParams}
        totalRecords={data?.length}
        onDataTableEvent={onDataTableEvent}
        enableCreate={false}
        enablePagination={true}
        enableLazyLoading={false}
        enableExport={true}
        actions={actions}
        sectionName={"Logs"}
      />
    </div>
  );
};
 
export default UserLogs;
 